var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-fuild"},[_c('Header')],1),_c('PageView'),_c('div',{staticClass:"container-fuild"},[_c('Footer')],1),_c('GoTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }